var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('MainDashboard'),(_vm.showSA)?_c('DashboardSuperAdmin'):(_vm.showOrga && _vm.orga)?_c('DashboardOrganisationAdmin',{attrs:{"id":_vm.orga.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }